<script setup>
import { ElPopover } from 'element-plus'
import { QuestionFilled } from '@element-plus/icons-vue'

defineProps({
  title: String,
  placement: {
    type: String,
    default: 'top-start',
  },
})
</script>
<template>
  <el-popover :placement="placement" :title="title" width="220px" trigger="hover">
    <template #reference>
      <el-icon color="#00000040">
        <QuestionFilled />
      </el-icon>
    </template>
    <slot />
  </el-popover>
</template>
<style lang="scss">
.el-popper * + * {
  margin-top: initial;
}
</style>
